import { Component, OnInit, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from '../services/jrni/api.service';
import { DatastoreService } from '../services';
import { AppConfig } from '../app.config';
import { HttpClient } from '@angular/common/http';

// Required for MSAL
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AccountInfo, EventMessage, EventPayload, EventType, InteractionStatus, RedirectRequest } from '@azure/msal-browser';

// Required for RJXS
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { _ } from '@ngx-translate/core';

@Component({
	selector: 'app-agent',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './agent.component.html',
	styleUrl: './agent.component.scss',
})
export class AgentComponent implements OnInit {

  loginDisplay = false;
  tokenExpiration = '';
  loggedIn = false;
  private readonly _destroying$ = new Subject<void>();
  config: any;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private spinner: NgxSpinnerService,
    private dataStore: DatastoreService,
    private apiService: ApiService,
    private http: HttpClient
  ) { }

  async ngOnInit() {
    // now we do the sso
    this.spinner.show();
    const appConfig: any = await this.apiService.getConfig(AppConfig.settings.core.company_id);
    this.config = appConfig;
        
    this.dataStore.config = appConfig;

    this.msalBroadcastService.inProgress$
        .pipe(
        filter((status: InteractionStatus) => {console.log('status', status); return status === InteractionStatus.None}),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        // console.log('getActiveAccount', this.authService.instance.getActiveAccount());
        const accounts = this.authService.instance.getAllAccounts();
        console.log('accounts', accounts);
        if (accounts.length < 1) {
          this.login();
        }
        else {
          this.loggedIn = true;
          this.authenticateUser(accounts[0]);
        }
      });;
    // Used for storing and displaying token expiration
    this.msalBroadcastService.msalSubject$.pipe().subscribe((msg) => {
      console.log('msalSubject', msg);
    });
    this.msalBroadcastService.msalSubject$.pipe(filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)).subscribe(msg => {
      this.loggedIn = true;
      console.log('login', msg);
      const accounts = this.authService.instance.getAllAccounts();
      if (accounts.length > 0) {
        this.authenticateUser(accounts[0]);
      }
    });
    this.msalBroadcastService.msalSubject$.pipe(filter((msg: EventMessage) => msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS)).subscribe(msg => {
      this.loggedIn = true;
      console.log('login', msg);
      const accounts = this.authService.instance.getAllAccounts();
      if (accounts.length > 0) {
        this.authenticateUser(accounts[0]);
      }
    });
    // this.msalBroadcastService.msalSubject$.pipe(filter((msg: EventMessage) => msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS)).subscribe(msg => {
    //   console.log(msg);
    // });
  }

  async authenticateUser(payload: AccountInfo) {
    const nameParts = payload.name.split(' ');
    console.log(nameParts);
    try {
      const improvedNameParts = payload.name.split(',');
      const lastName = improvedNameParts[0];
      const firstName = improvedNameParts[1].split(':')[0];
      const token:any = await this.apiService.generateSSOToken(this.config.company, firstName.trim(), lastName.trim(), payload.username);
      const loginObject:any = await this.apiService.ssoLoginAdmin(this.config.company, token.token);
      localStorage.setItem('agent', JSON.stringify(loginObject._embedded.administrators[0]));
      localStorage.setItem('auth_token', loginObject.auth_token);
      this.http.get('https://graph.microsoft.com/v1.0/me')
        .subscribe(profile => {
          localStorage.setItem('agent_profile', JSON.stringify(profile));
          window.location.assign(`/services?admin-only=true&auth_token=${loginObject.auth_token}`);
        });
    }
    catch (err) {
      console.error(err);
      const lastName = nameParts[0];
      const firstName = nameParts[1];
      const token:any = await this.apiService.generateSSOToken(this.config.company, firstName.trim(), lastName.trim(), payload.username);
      const loginObject:any = await this.apiService.ssoLoginAdmin(this.config.company, token.token);
      localStorage.setItem('agent', JSON.stringify(loginObject._embedded.administrators[0]));
      localStorage.setItem('auth_token', loginObject.auth_token);
      this.http.get('https://graph.microsoft.com/v1.0/me')
        .subscribe(profile => {
          localStorage.setItem('agent_profile', JSON.stringify(profile));
          window.location.assign(`/services?admin-only=true&auth_token=${loginObject.auth_token}`);
        });
    }
  }

  login() {
    if (this.msalGuardConfig.authRequest) {
      this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  // Log the user out
  logout() {
    this.authService.logoutRedirect();
  }


}
